import {
  ButtonProps,
  BorderProps,
  TextFieldProps,
  TextProps,
} from 'spindl-shared-components';

type TeammateInviteModalInternalProps = {
  title?: TextProps;
  closeButton?: ButtonProps;
  border?: BorderProps;
  emailField?: TextFieldProps;
  addButton?: ButtonProps;
  add?: ButtonProps;
};

type TeammateInviteModalPropsValues = {
  '': TeammateInviteModalInternalProps;
};

const propValues: TeammateInviteModalPropsValues = {
  '': {
    title: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Default',
      type: 'Heading5',
    },
    closeButton: {
      type: 'Icon',
      size: 'Small',
      styleType: 'PrimaryGhost',
      state: 'Default',
    },
    border: {
      colour: 'SubduedLight',
      type: 'Horizontal',
      styleType: 'Default',
    },
    emailField: {
      state: 'Default',
      type: 'Text',
      error: 'None',
    },
    addButton: {
      type: 'TextIcon',
      size: 'Medium',
      styleType: 'Primary',
      state: 'Default',
    },
    add: {
      type: 'TextIcon',
      size: 'Medium',
      styleType: 'Primary',
      state: 'Default',
    },
  },
};

const getProps = (type: string): TeammateInviteModalInternalProps => {
  const values: TeammateInviteModalInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
